import { Link } from "react-router-dom";
import { BRAND_LOGO } from "../../lib/brand";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#040404] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src={BRAND_LOGO} alt="The Social Circle" className="h-14 w-14 rounded-full ring-1 ring-[#D4AF37]/40" />
          <p className="font-display text-lg text-white mt-4">The Social Circle</p>
          <p className="text-[11px] tracking-luxe uppercase text-[#D4AF37] mt-1">by Cornerstone</p>
          <p className="italic text-white/50 text-sm mt-4">"Bringing people and venues together."</p>
        </div>
        <div>
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37] mb-4">The Circle</p>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/partners" className="hover:text-white">Partner Venues</Link></li>
            <li><Link to="/events" className="hover:text-white">Events</Link></li>
            <li><Link to="/membership" className="hover:text-white">Membership</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37] mb-4">For Venues</p>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/partner-with-us" className="hover:text-white">Partner with us</Link></li>
            <li><Link to="/login" className="hover:text-white">Merchant login</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37] mb-4">Legal</p>
          <ul className="space-y-2 text-white/70 text-sm">
            <li>Terms & Conditions</li>
            <li>Privacy</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between text-[11px] uppercase tracking-luxe text-white/40">
          <span>© {new Date().getFullYear()} The Social Circle by Cornerstone</span>
          <span>Curated nightlife · Members only</span>
        </div>
      </div>
    </footer>
  );
}
